export default {
    getActions: state => state.actions,
    getFormActions: state => state.formActions,
    getRowActions: state => state.rowActions,
    getFixPackagesHeaderFields: state => state.fixPackagesHeaderFields,
    getALaCartePackagesHeaderFields: state => state.aLaCartePackagesHeaderFields
}
